import React from "react";
import { Typography } from "@material-ui/core";
import useStyles from "./styles";

export function DisbursementTimingExplanation() {
  const classes = useStyles();

  return (
    <div className={classes.paymentsTimingCopy}>
      <Typography>
        Please note the following same-day timing cut-offs for delivery of CYCLE
        payments:
      </Typography>
      <ul className={classes.list}>
        <li>
          <Typography>To the user’s DailyPay Account: 9PM ET</Typography>
          <ul>
            <li>
              <Typography>
                Note: As with any bank account, a new deposit triggers a
                reconciliation process to determine the updated balance. In the
                case of the DailyPay account, a positive balance will trigger an
                automatic payment to a user's primary bank account.
              </Typography>
            </li>
          </ul>
        </li>
        <li>
          <Typography>To all non-DailyPay Accounts: 3PM ET</Typography>
        </li>
      </ul>
    </div>
  );
}
